import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: colors.red.darken1, // #E53935
            secondary: colors.red.lighten4, // #FFCDD2
            accent: colors.indigo.base, // #3F51B5
            purple: "#4e6093",
            green: "#7ac462",
            greens: "#7ac462",
            orange:"#FE8F00",
            grey: "3c3c3b",
            greylight: "3c3c3b"

          },
        },
      },
});
